import { useNavigate } from "react-router-dom";
import { toastService } from "../../providers";
import { useRequestPinReset } from "../../hooks/queries/useAuthQueries";
import RequestResetEmail from "../../components/auth/RequestResetEmail/RequestResetEmail";
import { useLocationBanner } from "./hooks/useLocationBanner";
import { extractAxiosErrorMessage } from "../../services/utils/errorUtils";
import {
  parsePinCode,
  computePinLockedExpiry,
  PIN_LOCK_FALLBACK_MS,
} from "../../services/utils/pinAuthUtils";
import { AUTH_STEP_UP_CODES } from "../../components/auth/config/authActionCodes";
import { usePinLoginBlockStore } from "../../stores/useOtpBlockStore";

function RequestPinReset() {
  const navigate = useNavigate();
  const { banner, dismissBanner } = useLocationBanner();
  const { mutate: requestPinResetMutation, isPending } = useRequestPinReset();

  const handleSubmit = (email) => {
    requestPinResetMutation(email, {
      onSuccess: (data) => {
        const code = parsePinCode(null, data);

        if (code === AUTH_STEP_UP_CODES.PIN_LOCKED) {
          const blockExpiresAt = computePinLockedExpiry(
            data,
            PIN_LOCK_FALLBACK_MS,
          );
          usePinLoginBlockStore.getState().setOtpBlock(blockExpiresAt);
          navigate("/auth/login");
          return;
        }

        toastService.success(
          "If an account exists for this email, you will receive further instructions.",
        );
        setTimeout(() => {
          navigate("/auth/login");
        }, 1000);
      },
      onError: (error) => {
        toastService.error(
          extractAxiosErrorMessage(error, "Failed to send reset instructions"),
        );
      },
    });
  };

  return (
    <RequestResetEmail
      title="Forgot PIN"
      subtitle="Enter your email to receive PIN reset instructions"
      buttonLabel="Send Reset Instructions"
      onSubmit={handleSubmit}
      isPending={isPending}
      banner={banner}
      onBannerClose={dismissBanner}
    />
  );
}

export default RequestPinReset;
